module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_2_EMPRENDIMIENTO.1cd15f27.jpg";